import Config from './config';

export default {
  // Find a matching region object for either the country or continent
  // if none are found it will attempt to get the default settings.
  getRegion({ country = false, continent = false } = {}) {
    const { adunits } = Config.get();

    // Find our region
    let region = adunits.filter(
      (region) =>
        (country && region.country === country) ||
        (continent && region.continent === continent)
    );
    const defaultRegion = adunits.filter(
      (region) => region.country === '*' || region.continent === '*'
    );

    if (!region.length) {
      region = defaultRegion;
    }

    // No Positions
    if (region[0].positions === '*') {
      // Maybe in Country?
      const countryRegion = adunits.filter(
        (region) => country && region.country === country
      );
      if (countryRegion.length && countryRegion[0].positions !== '*') {
        region[0].positions = countryRegion[0].positions;
      } else {
        // Maybe in Continent?
        const continentRegion = adunits.filter(
          (region) => continent && region.continent === continent
        );
        if (continentRegion.length && continentRegion[0].positions) {
          region[0].positions = continentRegion[0].positions;
        }
      }
    }

    // Still no region found? Error
    if (!region.length) {
      throw 'NoDefaultRegionSet';
    }

    // Just get the first region result, should only be one.
    return region.shift();
  },

  // Determine the ad unit for the current ad position, this can
  // be based on either a region object, country or continent. It
  // will default to settings if they are defined and no other
  // matches are made. Amazing!
  getPosition({
    region = false,
    country = false,
    continent = false,
    position = 1,
  } = {}) {
    // Find our region
    if (!region) {
      region = this.getRegion({ country, continent });
    }

    // Find all matching position values
    position = String(position);
    const positions = Object.keys(region.positions);
    let pos = positions.filter((value) => value === position);

    // No position matches, find default
    if (!pos.length) {
      pos = positions.filter((value) => value === '*');
    }

    // No position matches, throw error
    if (!pos.length) {
      throw 'NoDefaultPosition';
    }

    // Return the correct value
    return region.positions[pos.shift()];
  },
};
